// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Header_shadow__dTYe2"};